export const isSafeLoginRedirectPath = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false;
  }

  return value.startsWith('/') && !value.startsWith('//') && !value.includes('\\');
};

export const getSafeLoginRedirectPath = (value: unknown, fallback = '/'): string =>
  isSafeLoginRedirectPath(value) ? value : fallback;
